import { getJSON } from 'bv-fetch';
import { locale } from 'state';

export default ({ eventIds }) => getJSON('/bv_api/scores', {
  event_ids: eventIds,
  locale: locale(),
});
